import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';

interface LoadingScreenProps {
  message?: string;
  showProgress?: boolean;
}

export const LoadingScreen: React.FC<LoadingScreenProps> = ({ 
  message = "Loading application...",
  showProgress = false 
}) => {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center space-y-6 max-w-md mx-auto px-6">
        {/* Loading Animation */}
        <div className="relative">
          <div className="w-16 h-16 mx-auto">
            <div className="absolute inset-0 rounded-full border-4 border-muted"></div>
            <div className="absolute inset-0 rounded-full border-4 border-primary border-t-transparent animate-spin"></div>
          </div>
        </div>

        {/* Loading Message */}
        <div className="space-y-2">
          <h2 className="text-xl font-semibold text-foreground">
            {message}
          </h2>
          <p className="text-sm text-muted-foreground">
            Please wait while we prepare your workspace
          </p>
        </div>

        {/* Progress Skeletons */}
        {showProgress && (
          <div className="space-y-3 w-full">
            <div className="flex items-center justify-between text-xs text-muted-foreground">
              <span>Initializing...</span>
              <span>Loading modules</span>
            </div>
            <Skeleton className="h-2 w-full rounded-full" />
          </div>
        )}

        {/* Feature Indicators */}
        <div className="grid grid-cols-3 gap-4 pt-4">
          {['Security', 'Performance', 'Reliability'].map((feature) => (
            <div key={feature} className="text-center">
              <div className="w-2 h-2 bg-primary rounded-full mx-auto mb-1"></div>
              <span className="text-xs text-muted-foreground">{feature}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};